import Base from './Base';
import MessageSimple from '../models/MessageSimple';

export default class MessagesSimple extends Base {
    get models() {
        const collection = this.data.map(item => new MessageSimple(item));
        collection.collection = this;

        return collection;
    }
}